<template>
	<NuxtLinkLocale
		v-if="link"
		:to="link.url"
		:class="['link-banner', color]"
		@click="pushTracking"
	>
		<div class="link-banner__content">
			<div class="link-banner__title">
				{{ link.text }}
			</div>
			<div v-if="description" class="link-banner__description">
				{{ description }}
			</div>
		</div>
		<SvgIcon v-if="icon" :icon="icon" class="link-banner__icon" />
	</NuxtLinkLocale>
</template>

<script setup>
const { pushGa4 } = useTracking();

const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const link = computed(() => props.fields?.link?.value);
const description = computed(() => props.fields?.description?.value);
const icon = computed(() => props.fields?.icon?.value);
const color = computed(() => props.fields?.color?.value);
const gtm = computed(() => props.fields?.gtm?.value);

function pushTracking() {
	pushGa4(gtm.value);
}
</script>

<style lang="scss">
.link-banner {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	text-decoration: none;
	color: var(--color-white, #fff);
	margin: 0 var(--spacing-2, 16px);
	padding: var(--spacing-2, 16px) var(--spacing-2, 16px);
	border-radius: 8px;
	border-top: 1px solid #454545;
	border-bottom: 1px solid #454545;
	background: var(--primary-color, #fff);
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);

	.link-banner__content {
		display: flex;
		flex-direction: column;
		justify-content: center;
		flex-grow: 1;
	}

	.link-banner__title {
		font-size: var(--text-xl, 24px);
		text-transform: uppercase;
		font-weight: 900;
		line-height: 120%;
		margin: 0;
		margin-bottom: var(--spacing-05, 4px);
	}

	.link-banner__description {
		font-size: var(--text-base, 16px);
		font-weight: 300;
		margin: 0;
		margin-bottom: var(--spacing-05, 4px);
	}

	.link-banner__icon path {
		fill: var(--color-white, #fff);
		width: 20px;
		height: 20px;
	}

	&.link-banner--home-page {
		width: 220px;
		margin-inline: auto;

		.link-banner__title {
			font-size: var(--text-base, 16px);
			font-weight: 700;
			margin: var(--spacing-05, 4px) 0;
			line-height: 140%;
		}
	}

	&.white {
		background: var(--color-white, #fff);
		color: var(--color-black, #000);

		path {
			fill: var(--color-black, #000);
		}
	}

	&.black {
		background: var(--color-black, #000);
		color: var(--color-white, #fff);

		path {
			fill: var(--color-white, #fff);
		}
	}

	&.orange,
	&.primary {
		background: var(--primary-color, #fd470b);
		color: var(--color-white, #fff);

		path {
			fill: var(--color-white, #fff);
		}
	}

	&.secondary {
		background: var(--secondary-color, #fd470b);
		color: var(--color-black, #000);

		path {
			fill: var(--color-black, #000);
		}
	}

	&.tertiary {
		background: var(--tertiary-color, #384039);
		color: var(--color-white, #fff);

		path {
			fill: var(--color-white, #fff);
		}
	}
}
</style>
